












import { HighlightsButtonMeta } from '@front-app/modules/group/highlights/model';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import { defineComponent, PropType } from '@vue/composition-api';
import BaseButtonRender from './BaseButtonRender.vue';

export default defineComponent({
	components: {
		BaseButtonRender,
	},
	props: {
		dontCaptureMousedown: {
			type: Boolean,
		},
		meta: {
			type: Object as PropType<HighlightsButtonMeta>,
			required: true,
		},
		icon: {
			type: [Object, Boolean] as PropType<FontAwesomeIconProps | false>,
			validator(val: FontAwesomeIconProps | false) {
				return val === false || Boolean(val.icon);
			},
			default: () => ({
				icon: 'link',
			}),
		},
	},
	setup() {
		return {};
	},
});
